import http from "./httpService";
import config from "./../config.json";

let apiEndpoint = process.env.REACT_APP_API_URL || config.apiUrl;
apiEndpoint += "journals";

export const saveJournalEntryAsync = async (data) => {
  return await http.post(apiEndpoint, data);
};

export const postUnpostedEntryAsync = async (data) => {
  const url = `${apiEndpoint}/unposted`;

  return await http.post(url, data);
};

export const saveJournalClientAsync = async (data) => {
  const url = `${apiEndpoint}/clients`;

  return await http.post(url, data);
};

export const saveAccountChartAsync = async (data) => {
  const url = `${apiEndpoint}/account-charts`;

  if (data.id) {
    return await http.put(url, data);
  }

  return await http.post(url, data);
};

export const generateClientRegistryAsync = async (id) => {
  const url = `${apiEndpoint}/reports/client-registry/${id}`;

  const { data } = await http.post(url);
  return data;
};

export const generateSeniorClientRegistryAsync = async (id) => {
  const url = `${apiEndpoint}/reports/senior-client-registry/${id}`;

  const { data } = await http.post(url);
  return data;
};

export const generateCashReceiptsAsync = async (id) => {
  const url = `${apiEndpoint}/reports/cash-receipts/${id}`;

  const { data } = await http.post(url);
  return data;
};

export const generateGeneralJournalAsync = async (id) => {
  const url = `${apiEndpoint}/reports/general-journals/${id}`;

  const { data } = await http.post(url);
  return data;
};

export const generateGeneralLedgerAsync = async (id) => {
  const url = `${apiEndpoint}/reports/general-ledger/${id}`;

  const { data } = await http.post(url);
  return data;
};

export const deleteAccountChartAsync = async (id) => {
  const url = `${apiEndpoint}/account-charts/${id}`;

  return await http.delete(url);
};

export const getUnpostedEntriesAsync = async (params) => {
  const {
    reference,
    sort_column,
    size,
    search_query: query,
    current_page: page,
  } = params;

  const { path: column, order } = sort_column;
  const url = `${apiEndpoint}/unposted?q=${query}&reference=${reference}&column=${column}&order=${order}&p=${page}&s=${size}`;

  const { data } = await http.get(url);
  return data;
};

export const getAccountClientRegistryReportAsync = async (id) => {
  const url = `${apiEndpoint}/accounts/client-registry/${id}`;
  const { data } = await http.get(url);

  return data;
};

export const getAccountSeniorClientRegistryReportAsync = async (id) => {
  const url = `${apiEndpoint}/accounts/senior-client-registry/${id}`;
  const { data } = await http.get(url);

  return data;
};

export const getAccountCashReceiptsAsync = async (id) => {
  const url = `${apiEndpoint}/accounts/cash-receipts/${id}`;
  const { data } = await http.get(url);

  return data;
};

export const getAccountGeneralJournalInfoAsync = async (id) => {
  const { data } = await http.get(
    `${apiEndpoint}/accounts/general-journal/${id}`
  );

  return data;
};

export const getAccountGeneralLedgerInfoAsync = async (id) => {
  const { data } = await http.get(
    `${apiEndpoint}/accounts/general-ledger/${id}`
  );

  return data;
};

export const getAccountJournalAsync = async (id) => {
  const { data } = await http.get(`${apiEndpoint}/accounts/${id}`);
  return data;
};

export const getAccountJournalEntriesAsync = async (id) => {
  const { data } = await http.get(`${apiEndpoint}/entries/accounts/${id}`);
  return data;
};

export const getJournalClientsAsync = async (params) => {
  const {
    sort_column,
    type,
    size,
    search_query: query,
    current_page: page,
  } = params;

  const { path: column, order } = sort_column;
  const url = `${apiEndpoint}/clients?q=${query}&type=${type}&column=${column}&order=${order}&p=${page}&s=${size}`;

  const { data } = await http.get(url);
  return data;
};

export const getAccountChartsAsync = async (params) => {
  const {
    sort_column,
    type,
    size,
    search_query: query,
    current_page: page,
  } = params;

  const { path: column, order } = sort_column;
  const url = `${apiEndpoint}/account-charts?q=${query}&type=${type}&column=${column}&order=${order}&p=${page}&s=${size}`;

  const { data } = await http.get(url);
  return data;
};

export const getAccountChartTypesAsync = async () => {
  const url = `${apiEndpoint}/account-charts/types`;
  const { data } = await http.get(url);
  return data;
};

export const getJournalReferences = () => {
  return [
    { label: "Official Receipt", value: 1 },
    { label: "2307", value: 2 },
    { label: "Payment", value: 3 },
  ];
};

export const journalService = {
  saveJournalEntryAsync,
  postUnpostedEntryAsync,
  saveJournalClientAsync,
  saveAccountChartAsync,
  generateClientRegistryAsync,
  generateSeniorClientRegistryAsync,
  generateCashReceiptsAsync,
  generateGeneralJournalAsync,
  generateGeneralLedgerAsync,
  deleteAccountChartAsync,
  getJournalClientsAsync,
  getUnpostedEntriesAsync,
  getAccountClientRegistryReportAsync,
  getAccountSeniorClientRegistryReportAsync,
  getAccountCashReceiptsAsync,
  getAccountGeneralJournalInfoAsync,
  getAccountGeneralLedgerInfoAsync,
  getAccountJournalAsync,
  getAccountJournalEntriesAsync,
  getAccountChartsAsync,
  getAccountChartTypesAsync,
  getJournalReferences,
};

export default journalService;
